export const calledOffPercent = (calledOff: number, maximum: number): number => {
  const rounded = Math.round((calledOff / maximum) * 100);
  if (calledOff > maximum) return Math.max(rounded, 101);
  if (calledOff < maximum) return Math.min(rounded, 99);
  return 100;
};
